import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import HsvDivider from "../HsvDivider/HsvDivider";
import { useCookieConsent } from "../../contexts/CookieConsentContext";
import * as styles from "./footerStyles";

const Footer: React.FC = () => {
    const { resetConsent } = useCookieConsent();

    return (
        <Box sx={styles.footerContentStyles}>
            <HsvDivider>
                <Box
                    component="img"
                    sx={styles.hsvDiamondLogo}
                    alt="HSV Raute"
                    src="/images/illustrations/hsv-diamond.svg"
                />
            </HsvDivider>

            <Box
                component="img"
                sx={styles.footerLogoStyles}
                alt="HSV Graffiti Logo"
                src="/images/illustrations/hsv-graffiti.svg"
            />

            <Box>
                <Box sx={styles.footerLinksContainer}>
                    <Link
                        component={RouterLink}
                        to="/impressum"
                        sx={styles.footerLink}
                    >
                        Impressum
                    </Link>
                    <Link
                        component={RouterLink}
                        to="/datenschutz"
                        sx={styles.footerLink}
                    >
                        Datenschutz
                    </Link>
                </Box>

                <Link
                    component="button"
                    onClick={resetConsent}
                    sx={styles.consentLink}
                >
                    Cookie-Einstellungen
                </Link>
            </Box>
        </Box>
    );
};

export default Footer;
